// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"4":"e56809e3","56":"c98916a1","239":"76ebad4b","305":"2631b58a","389":"8ef546ab","403":"7925de4c","455":"c48a2cc9","772":"91760f6b","884":"91d04810","928":"15408a0e","959":"2674b6c8"}[chunkId] + ".chunk.js";
};